export default "__VITE_ASSET__DdBc83eb__"